module.exports = __webpack_public_path__ + "assets/img/page-background-08453386.png";